namespace $ { export class $piterjs_logo extends $piterjs_image {

	/**
	 *  ```
	 *  link \piterjs/logo/logo.svg
	 *  ```
	 **/
	link() {
		return "piterjs/logo/logo.svg"
	}

} }
